/**
 * Dev-mode auth bootstrap.
 *
 * При APP_ENV=local backend поднимает /api/dev/bootstrap-session, который
 * ставит HttpOnly-cookie на seeded-admin'а и отдаёт user в теле
 * Вызываем дважды: при старте приложения (через main.tsx) и как retry на
 * первый 401 (см. api.ts recoverFrom401)
 *
 * В prod-сборке endpoint вернёт 404 - и мы тихо упадём, пользователь
 * залогинится через обычный /login.
 */
import { useAuth, type CurrentUser } from "@/stores/auth";
import { api, ApiHttpError } from "@/lib/api";

interface BootstrapResponse {
  token?: string;        // legacy, фронт его игнорирует
  user: CurrentUser;
}

export async function ensureDevSession(): Promise<void> {
  // Если cookie уже валидна - /me ответит 200. Используем как probe.
  try {
    const me = await api.get<CurrentUser>("/auth/me");
    useAuth.getState().setUser(me);
    return;
  } catch (err) {
    if (!(err instanceof ApiHttpError) || ![401, 403].includes(err.status)) {
      // unrelated error (network) - не пытаемся bootstrap'ить, но всё
      // равно помечаем что auth-проверка завершена, иначе RequireAuth
      // будет показывать spinner вечно
      useAuth.getState().setAuthChecked(true);
      return;
    }
    // 401/403 - кука протухла/нет, попробуем dev-bootstrap
  }

  try {
    const r = await api.post<BootstrapResponse>("/dev/bootstrap-session");
    useAuth.getState().setUser(r.user);
  } catch (err) {
    if (!(err instanceof ApiHttpError) || err.status !== 404) {
      console.warn("Dev bootstrap unavailable:", err);
    }
    // 404 = prod-сборка - юзер просто гость, помечаем auth-checked.
    useAuth.getState().setAuthChecked(true);
  }
}
